    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            media: []
        }
    }
    
    const state = getDefaultState()

    const getters = {
        media: state => {
            return state.media
        },
       
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        media: (state, payload) => {
            state.media = payload
        }
    }

    const actions = {
       
        getMedia: ({commit}) =>{
            
            commit('updating', true)
            axiosAuth.get('/media')
            .then(
                res => {
                    commit('updating', false)
                    commit('media', res.data)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

    }

    export default {
        state,
        getters,
        mutations,
        actions
    }